import Immutable from 'immutable';
import * as types from './AdminApparelItems.types';

const initialState = {
    type: null,
    apparelItems: [],
    fetching: false,
    saving: false,
    idModal: null,
    pagination: {
        totalElements: 0,
        activePage: 1,
        totalPages: 0,
        elementsPerPage: 15,
    },
    apparelItem: {
        allow_utp: 0,
        allow_uth: 0,
        allow_manager: 0,
        allow_personal: 0,
        allow_coupa: 0,
        allow_personalization: 0,
        enabled: 0,
        departments_ids: [],
    },
    tileImage: null,
    image1: null,
    image2: null,
    image3: null,
    departments: [],
    fetchingDepartments: false,
    isDeleting: false,
    sort: {
        column: 'name',
        type: 'asc',
    },
    search: '',
    searchType: 'name',
    isUploading: false,
    uploadFile: null,
    allDepartments: [],
    sizeCharts: [],
    showUtp: 1,
    showUth: 1,
}

export default function (state = initialState, action) {
    state = Immutable.fromJS(state);
    switch (action.type) {
        case types.FETCH_APPAREL_ITEMS:
            return state.setIn(['fetching'], true).toJS();

        case types.FETCH_APPAREL_ITEMS_SUCCESS:
            return state.setIn(['fetching'], false)
                .setIn(['apparelItems'], action.payload.elements)
                .setIn(['pagination', 'totalElements'], action.payload.totalElements)
                .setIn(['pagination', 'activePage'], action.payload.activePage)
                .setIn(['pagination', 'totalPages'], action.payload.totalPages)
                .setIn(['pagination', 'elementsPerPage'], action.payload.elementsPerPage)
                .toJS();

        case types.FETCH_APPAREL_ITEMS_ERROR:
            return state.setIn(['fetching'], false).toJS();

        case types.FETCH_DEPARTMENTS:
            return state.setIn(['fetchingDepartments'], true).toJS();

        case types.FETCH_DEPARTMENTS_SUCCESS:
            return state.setIn(['fetchingDepartments'], false)
                .setIn(['departments'], action.payload.parentCategories)
                .setIn(['allDepartments'], action.payload.allCategories)
                .setIn(['sizeCharts'], action.payload.sizeCharts)
                .toJS();

        case types.FETCH_DEPARTMENTS_ERROR:
            return state.setIn(['fetchingDepartments'], false).toJS();

        case types.SAVE_APPAREL_ITEM:
            return state.setIn(['saving'], true).toJS();

        case types.SAVE_APPAREL_ITEM_SUCCESS:
            return state.setIn(['saving'], false)
                .setIn(['idModal'], null)
                .toJS();

        case types.SAVE_APPAREL_ITEM_ERROR:
            return state.setIn(['saving'], false).toJS();

        case types.DELETE_APPAREL_ITEM:
            return state.setIn(['isDeleting'], true).toJS();

        case types.DELETE_APPAREL_ITEM_SUCCESS:
            return state.setIn(['isDeleting'], false)
                .setIn(['idModal'], null)
                .toJS();

        case types.DELETE_APPAREL_ITEM_ERROR:
            return state.setIn(['isDeleting'], false).toJS();

        case types.UPLOAD_FILE:
            return state.setIn(['isUploading'], true).toJS();

        case types.UPLOAD_FILE_SUCCESS:
            return state.setIn(['isUploading'], false)
                .setIn(['uploadFile'], null)
                .toJS();

        case types.UPLOAD_FILE_ERROR:
            return state.setIn(['isUploading'], false).toJS();

        case types.SET_ID_MODAL:
            return state.setIn(['idModal'], action.payload).toJS();

        case types.SET_ACTIVE_PAGE:
            return state.setIn(['pagination', 'activePage'], action.payload).toJS();

        case types.SET_APPAREL_ITEM_FIELD:
            return state.setIn(['apparelItem', action.payload.field], action.payload.value).toJS();

        case types.SET_APPAREL_ITEM:
            return state.setIn(['apparelItem'], action.payload).toJS();

        case types.SET_TILE_IMAGE:
            return state.setIn(['tileImage'], action.payload).toJS();

        case types.SET_IMAGE1:
            return state.setIn(['image1'], action.payload).toJS();

        case types.SET_IMAGE2:
            return state.setIn(['image2'], action.payload).toJS();

        case types.SET_IMAGE3:
            return state.setIn(['image3'], action.payload).toJS();

        case types.SET_UPLOAD_FILE:
            return state.setIn(['uploadFile'], action.payload).toJS();

        case types.RESET_APPAREL_ITEM:
            return state.setIn(['apparelItem'], {
                allow_utp: 0,
                allow_uth: 0,
                allow_manager: 0,
                allow_personal: 0,
                allow_coupa: 0,
                enabled: 0,
            }).toJS();

        case types.SET_SORT:
            return state.setIn(['sort', 'type'], action.payload.type)
                .setIn(['sort', 'column'], action.payload.column)
                .toJS();

        case types.SET_SEARCH:
            return state.setIn(['search'], action.payload).toJS();

        case types.SET_SEARCH_TYPE:
            return state.setIn(['searchType'], action.payload).toJS();

        case types.ADD_DEPARTMENT:
            return state.updateIn(['apparelItem', 'departments_ids'], (departmentsIds) => {
                let newDepartmentIds = [];
                if (departmentsIds) {
                    newDepartmentIds = departmentsIds.toJS();
                }
                newDepartmentIds.push(action.payload);
                return newDepartmentIds;
            }).setIn(['apparelItem', 'department_id'], '').toJS();

        case types.DELETE_DEPARTMENT:
            return state.updateIn(['apparelItem', 'departments_ids'], (departmentsIds) => {
                let newDepartmentIds = departmentsIds.toJS();
                newDepartmentIds.splice(action.payload, 1);
                return newDepartmentIds;
            }).toJS();

        case types.SET_SHOW_UTP:
            return state.setIn(['showUtp'], action.payload).toJS();

        case types.SET_SHOW_UTH:
            return state.setIn(['showUth'], action.payload).toJS();

        case types.RESET_STATE:
            return initialState;

        default:
            return state.toJS();
    }
}